import { useEffect, useState } from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const NAV_LINKS = [
  { label: 'About',      id: 'about'      },
  { label: 'Skills',     id: 'skills'     },
  { label: 'Experience', id: 'experience' },
  { label: 'Projects',   id: 'projects'   },
  { label: 'Contact',    id: 'contact'    },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive]     = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setActive(id);
  };

  return (
    <nav
      className={`sticky top-0 w-full h-[72px] flex items-center justify-between px-6 sm:px-10 z-50 transition-all duration-300 ${
        scrolled ? 'glass-dark border-b border-cyan-900/30 shadow-lg' : 'bg-transparent'
      }`}
    >
      {/* Logo */}
      <div
        className="font-black text-xl tracking-[0.15em] select-none"
        style={{
          fontFamily: "'Orbitron', monospace",
          background: 'linear-gradient(135deg, #00f5ff, #ff00de)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        &lt;ABHI /&gt;
      </div>

      {/* Desktop nav links */}
      <div className="hidden md:flex items-center gap-6">
        {NAV_LINKS.map(({ label, id }) => (
          <button
            key={id}
            onClick={() => scrollTo(id)}
            className="text-xs font-mono tracking-[0.15em] uppercase transition-all duration-200"
            style={{
              color: active === id ? '#00f5ff' : '#94a3b8',
              textShadow: active === id ? '0 0 8px #00f5ff' : 'none',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#00f5ff';
              e.currentTarget.style.textShadow = '0 0 8px #00f5ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = active === id ? '#00f5ff' : '#94a3b8';
              e.currentTarget.style.textShadow = active === id ? '0 0 8px #00f5ff' : 'none';
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Social icons */}
      <div className="flex items-center gap-4">
        <a
          href="https://www.linkedin.com/in/abhiramgargeya/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-all duration-200"
          style={{ color: '#94a3b8' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#00f5ff';
            e.currentTarget.style.filter = 'drop-shadow(0 0 6px #00f5ff)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#94a3b8';
            e.currentTarget.style.filter = 'none';
          }}
        >
          <FaLinkedin size={22} />
        </a>
        <a
          href="https://github.com/AbhiramGarg/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-all duration-200"
          style={{ color: '#94a3b8' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#00f5ff';
            e.currentTarget.style.filter = 'drop-shadow(0 0 6px #00f5ff)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#94a3b8';
            e.currentTarget.style.filter = 'none';
          }}
        >
          <FaGithub size={22} />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
